export default __webpack_public_path__ + "static/media/patient-room.7916b1b7.jpg";